import React from "react";
import { Route, Routes } from "react-router-dom";
import FactSheet from "../Page/FactSheet";
import HomePage from "../Page/HomePage/HomePage";
import Auth from "../Page/Auth";
import SignUp from "../Page/SignUp";
import RequiredAuth from "../HOC/requiredAuth";
import SortingModelTest from "../Page/SortingModelTest";

import LandingPage from "../Page/HomePage"; // don't remove this
import Error from "../Page/Error";
import ReleaseNotes from "../Page/ReleaseNotes";

const AllRoutes = ({
  toggleState,
  state,
  resetFlag,
  setResetFlag,
}) => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <RequiredAuth>
            <HomePage
              toggleState={toggleState}
              state={state}
              resetFlag={resetFlag}
              setResetFlag={setResetFlag}
            />
          </RequiredAuth>
        }
      />
      <Route
        path="/hospitals/:id"
        element={
          <RequiredAuth>
            <FactSheet toggleState={toggleState} state={state} />
          </RequiredAuth>
        }
      />
      <Route
        path="/sorting-model-test"
        element={
          <RequiredAuth>
            <SortingModelTest />
          </RequiredAuth>
        }
      />
      <Route
        path="/release-notes"
        element={
          <RequiredAuth>
            <ReleaseNotes />
          </RequiredAuth>
        }
      />
      <Route path="/sign-in" element={<Auth />} />
      <Route path="/sign-up" element={<SignUp />} />
      <Route path="*" element={<RequiredAuth> <Error /></RequiredAuth>} />
    </Routes>
  );
};

export default AllRoutes;
